import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { corporate_landing_path } from '@routes';
import { ClickTarget, click } from '@tracking';

const CorporateInquiry = () => {
  const { trackEvent } = useEventTracking();

  return (
    <div className="mt-32 flex flex-wrap items-center justify-center text-center font-suisse-intl">
      <div className="mr-4 text-caption-lg text-grayscale-gray">
        Group or corporate subscription?
      </div>
      <a
        href={corporate_landing_path()}
        className="font-medium text-primary-magenta visited:text-primary-magenta"
        onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.CorporateInquiry }))}
      >
        Explore options here
      </a>
    </div>
  );
};

export default CorporateInquiry;
